import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-choose-login',
  templateUrl: './choose-login.component.html',
  styleUrls: ['./choose-login.component.scss']
})
export class ChooseLoginComponent {
  selectedType: 'login' | 'login-as-company' | null = null;

  constructor(private router: Router) {}

  /**
   * Sélectionne le type de connexion
   */
  selectLoginType(type: 'login' | 'login-as-company') {
    this.selectedType = type;
  }

  /**
   * Navigue vers la page de connexion appropriée
   */
  navigateToLogin(type: 'login' | 'login-as-company') {
    if (type === 'login') {
      // Navigation vers la page de connexion comité d'organisation
      this.router.navigate(['/login'], { queryParams: { type: 'login' } });
    } else if (type === 'login-as-company') {
      // Navigation vers la page de connexion entreprise
      this.router.navigate(['/login-as-company'], { queryParams: { type: 'login-as-company' } });
    }
  }
}
